import { Component, OnInit, Inject,EventEmitter,Output } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LeagueRegPopupComponent } from '../league-reg-popup/league-reg-popup.component';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs/internal/Subscription';
import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { TournamentService } from 'src/app/tournamentpopup/tournament.service';
import { environment } from 'src/environments/environment';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ConfirmboxComponent } from '../confirmbox/confirmbox.component';
import { VerificationComponent } from 'src/app/verification/verification.component';
import { PhoneVerificationComponent } from 'src/app/phone-verification/phone-verification.component';
import { UserBalanceData } from './../store/actions/appActions';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { LobbyService } from './../_services/lobby.service';

@Component({
  selector: 'app-tournamentpopup',
  templateUrl: './tournamentpopup.component.html',
  styleUrls: ['./tournamentpopup.component.scss']
})
export class TournamentpopupComponent implements OnInit, OnDestroy {
  [x: string]: any;
  public screenHeightForModal: any;  
  assetURL: string;
  parameters: any;
  user_id = 0;
  currentUser: any;
  infoData: any;
  scoringData: any;
  entrantsData: any = [];
  searchEntrantsData: any = [];
  sub_result: Subscription;
  page_no = 0;
  endPoint = 0;
  isMobile = false;
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  leagueDialogRef: MatDialogRef<LeagueRegPopupComponent>;
  verificationRef: MatDialogRef<VerificationComponent>;
  phoneVerificationRef: MatDialogRef<PhoneVerificationComponent>;
  siteUrl:string;
  tournament:string;
  joinLeagueData:any;
  updated_balance:any;  
  darkMode= false;
  darkMode_ext= '';
  curSearch= '';
  showNoRecord= false;
  showRounds= true;
  loading= false;
  showprogressbar= false;
  milestoneDetails:any=[];
  milestoneMessage : string ='';
  @Output() closePopupAndNavigate = new EventEmitter<any>();
  constructor(public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) private data,
    private spinner: NgxSpinnerService,
    private tournamentService: TournamentService,
    private deviceService: DeviceDetectorService,
    public gamePreviewDialogRef: MatDialogRef<TournamentpopupComponent>,
    private router: Router,
    private store: Store<AppState>,
    private _lobbyService: LobbyService,
  ) {
    this.isMobile = this.deviceService.isMobile();
    this.parameters = data;
    this.store.select('DarkModeReducer').subscribe(state => {
      if (state.length > 0) {
        this.darkMode = state[0].isDarkMode;
        this.darkMode_ext = this.darkMode?'_icon-dark':'';
      }
    });
    this.sub_joinTournament = this._lobbyService.updateTournamentMember().subscribe(state => {
      if (state.status != null && state.status == 1 && state.tournament_id == this.infoData.tournament_id) {
        if(state.entities && state.entities.total_entries) this.infoData.joined_entrants = state.entities.total_entries;
        const draftNow = (state.entities.is_fast == 1) ? "Draft Now (Fast)": "Draft Now (Slow)" ;
        this.incrementDraftNowSlowValue(state.entities.action, draftNow); 
      }
  });
}
  
  incrementDraftNowSlowValue(action, draftNow) {
    const item = this.infoData.info.find(item => item.label === draftNow);
    if (item) {
      const [current, max] = item.value.split("/").map(Number);
      if(action == "join" && current != max){
          item.value = `${current + 1}/${max}`;
      }else{
        item.value = `${current - 1}/${max}`;
      }
    }
  }

  joinLeaguePopup(league_code, second_per_pick) {
    if(Number(this.infoData.drafttype_id) === 4){
      this.spinner.hide();
      this.closePopupAndNavigate.emit('/rankem/'+this.infoData.league_type+'/'+this.parameters.league_id);
      return false;
    } else if (Number(this.infoData.drafttype_id) == 5){
      this.closePopupAndNavigate.emit('/tiers/'+this.parameters.league_id);
      return false;
    }
    this.spinner.show();
    this.tournamentService.getUserLocation(this.user_id, locationData => {
      locationData['league_code'] = league_code;
      locationData['user_id'] = this.user_id;
      locationData['second_per_pick'] = second_per_pick;
      this.sub_result = this.tournamentService.getJoinPopUpData(locationData).subscribe(res => {
        this.spinner.hide();
        if (typeof res !== 'undefined' && res.status === 'success') {
          this.joinLeagueData = res.entities;
          console.log(this.joinLeagueData.join_verify_check != null)
          if(this.joinLeagueData.join_verify_check == 1 && this.joinLeagueData.payment_verified == 'N'){
            //Profile not verified?
            this.verificationRef = this.dialog.open(VerificationComponent, {
              width: '600px',
              data: { }
            });
          } else if(this.joinLeagueData.join_verify_check == 1 && this.joinLeagueData.verify_phone == 'N'){
            //Phone number not verified?
            this.phoneVerificationRef =  this.dialog.open(PhoneVerificationComponent, {
              width: '500px',
              data: {}
            });
          } else if(this.joinLeagueData && this.infoData && (Number(this.joinLeagueData.balance) < Number(this.joinLeagueData.league_fee))  && (!this.joinLeagueData.hasTicket)){
            this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
              width: '500px',
              data: { 'title': "Deposit", 'body': '','type':'deposit_fee','league_type':this.infoData.league_type,'name':this.infoData.name,'balance_text':this.joinLeagueData.balance_text,'entry_fee':this.joinLeagueData.entry_fee }
            });
            
            this.confirmDialogRef.afterClosed()
            .subscribe(res => {
              if (res) {
                this.gamePreviewDialogRef.close(2); 
              }
            })
          }else{
            //const remaining_people = Number(this.infoData.entrants) - Number(this.infoData.joined_entrants);
            this.leagueDialogRef = this.dialog.open(LeagueRegPopupComponent, {
              width: '550px',
              data: { 'league_code': league_code, 'draft_type': 'tournament','result':this.joinLeagueData,'remaining_people':this.parameters.remain_people, 'league_id': this.parameters.league_id, 'tournament_code':this.infoData.tournament_code  }
            });
        
            this.leagueDialogRef.afterClosed()
            .subscribe(res => {
              if (res) { 
                this.gamePreviewDialogRef.close(1); 
              }
            })
          }
        }
        else {
          this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
              width: (res.type == 'age_18') ? '500px' : '800px',
              data: { 'title': "Eligibility Warning", 'body': res.message,'type':res.type }
            });
            
            this.confirmDialogRef.afterClosed()
            .subscribe(res => {
              if (res) {
                this.gamePreviewDialogRef.close(2); 
              }
            })
        }
      });
    });
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (this.currentUser != null) {
      this.user_id = this.currentUser.id;
    }
    this.assetURL = `${environment.assetURL}`;
    this.siteUrl = `${environment.SITE_URL}`;
    this.tournament = `${environment.tournament}`;
    this.spinner.show();
    this.getCurrentTabData('info');
    this.screenHeightForModal = window.innerHeight<600?['70vh','56vh']:['61vh','46vh'];
  }

  tourTabChanged(event) {
    if (event.index == 1 && this.scoringData == null) {
      this.getCurrentTabData('scoring');
    }
    else if (event.index == 3 && this.entrantsData.length == 0) {
      // this.getCurrentTabData('entrants');
    }else if (event.index == 2){
      const tournamentId = this.infoData && this.infoData.tournament_id ? this.infoData.tournament_id :"";
      const isMilestone = this.infoData && this.infoData.isMilestone ? this.infoData.isMilestone :0;
      if(tournamentId && isMilestone) this.getMiletoneDetails(tournamentId);
    }
  }
  getMiletoneDetails(tournamentId){
    this.loading = true;
    this.tournamentService.getMiletoneDetails(tournamentId).subscribe(res => {
      this.loading = false;
      if (typeof res !== 'undefined' && res.status) {
        this.milestoneDetails = (res.entities&&res.entities.milestone_configuration) ? res.entities.milestone_configuration : [];
        this.milestoneMessage = (res.entities && res.entities.milestone_message) ? res.entities.milestone_message : '';
        if(this.milestoneDetails.length>0){
          this.showNoRecord = false;
        } else {
          this.showNoRecord = true;
        }
      }
    });
  }

  getCurrentTabData(tab_name) {
    this.loading = true;
    this.sub_result = this.tournamentService.getTournamentData(this.parameters.tournament_id, this.parameters.league_id, this.user_id, tab_name, this.page_no,this.curSearch).subscribe(res => {
      this.loading = false;
      this.showprogressbar = false;
      if (typeof res !== 'undefined' && res.status === 'success') {
        if (tab_name === 'info') {
          this.spinner.hide();
          this.infoData = res.entities; 
        } else if (tab_name === 'scoring') {
          this.scoringData = res.entities;
        } else if (tab_name === 'entrants') {
          this.entrantsData = this.entrantsData.concat(res.entities);
          if(this.page_no==0){
            this.searchEntrantsData = [];
          }
          if (this.page_no != 0) {            
            this.searchEntrantsData =  this.searchEntrantsData.concat(res.entities);
          } else {
            this.page_no=1;
            this.searchEntrantsData = res.entities;
          }
          if(this.searchEntrantsData.length>0){
            this.showNoRecord =false;
          } else {
            this.showNoRecord =true;
          }
          if (res.entities.length != 0) {
            this.endPoint = 0;
          } else {
            this.endPoint = 1;
          }
        }
      }
    });
  }
  
  confirmDialog(league_code, second_per_pick, tournament_id) {
    this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
      width: '500px',
      data: { 'title': this.infoData.name, 'body': 'Are you sure you want to leave this league?','type':'confirm_popup' }
    });
     
    this.confirmDialogRef.afterClosed()
    .subscribe(res => {
       if (res) {
        this.leaveLeague(league_code, second_per_pick, tournament_id)
       }
    })
  }

  leaveLeague(league_code, second_per_pick, tournament_id) {
    this.spinner.show();
    this.sub_result = this.tournamentService.draftLeaveLeagueRequest({league_code, second_per_pick, tournament_id}).subscribe(res => {
      this.spinner.hide();
      if (typeof res !== 'undefined' && res.status === 'success') {
        this.updated_balance = (res.entities != null && res.entities.updated_balance != null) ? res.entities.updated_balance : '0';
        /**Update store data */
        this.store.dispatch(new UserBalanceData(
          this.updated_balance
        ));
        this.gamePreviewDialogRef.close(2);
      }
    });
  }

  onScrollEvent(ev) {
    if(this.entrantsData.length < +(this.infoData.joined_entrants))
    {
      if (this.endPoint === 0) {
        this.getCurrentTabData('entrants');
        this.page_no += 1;
      }
    }
  }
  
  scheduleInfoPopup(tlgid) {
    this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
      width: '700px',
      data: { 'title': "Schedules", 'body': '', 'type': 'game_schedules', 'league_id':tlgid!=null?tlgid:this.parameters.league_id, 'user_id':this.user_id}
    });
    
    this.confirmDialogRef.afterClosed()
    .subscribe(res => {})
  }

  ngOnDestroy() {
    this.sub_result.unsubscribe();
  }
  updateSearch(value){
    if(this.loading){
      return false;
    }
    this.showprogressbar = true;
    this.curSearch = value;
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.page_no =0;
      this.entrantsData =[];
      this.getCurrentTabData('entrants');
    }, 800);
  }
}
